/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './oneiam-error.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/errors/oneiam-error/oneiam-error.component';
import * as i3 from '@angular/router';
const styles_OneiamErrorComponent:any[] = [i0.styles];
export const RenderType_OneiamErrorComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_OneiamErrorComponent,data:{}});
export function View_OneiamErrorComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'div',[['class',
      'container mt-4']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),4,'div',[['class','alert alert-warning'],['role','alert']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    Sorry, we are unable to log you in. Please '])),
      (_l()(),i1.ɵeld(4,0,(null as any),(null as any),1,'a',[['class','alert-link']],
          [[8,'href',4]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['try again'])),(_l()(),i1.ɵted(-1,(null as any),
          ['. If the problem\n    persists, please contact the support team.\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (null as any),(_ck,_v) => {
        var _co:i2.OneiamErrorComponent = _v.component;
        const currVal_0:any = _co.loginUrl;
        _ck(_v,4,0,currVal_0);
      });
}
export function View_OneiamErrorComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'oneiam-error',
      ([] as any[]),(null as any),(null as any),(null as any),View_OneiamErrorComponent_0,
      RenderType_OneiamErrorComponent)),i1.ɵdid(1,245760,(null as any),0,i2.OneiamErrorComponent,
      [i3.ActivatedRoute],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const OneiamErrorComponentNgFactory:i1.ComponentFactory<i2.OneiamErrorComponent> = i1.ɵccf('oneiam-error',
    i2.OneiamErrorComponent,View_OneiamErrorComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9hcHAvc3JjL2FwcC9lcnJvcnMvb25laWFtLWVycm9yL29uZWlhbS1lcnJvci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2FwcC9zcmMvYXBwL2Vycm9ycy9vbmVpYW0tZXJyb3Ivb25laWFtLWVycm9yLmNvbXBvbmVudC50cyIsIm5nOi8vL3Zhci9hcHAvc3JjL2FwcC9lcnJvcnMvb25laWFtLWVycm9yL29uZWlhbS1lcnJvci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9hcHAvc3JjL2FwcC9lcnJvcnMvb25laWFtLWVycm9yL29uZWlhbS1lcnJvci5jb21wb25lbnQudHMuT25laWFtRXJyb3JDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwiY29udGFpbmVyIG10LTRcIj5cbiAgPGRpdiBjbGFzcz1cImFsZXJ0IGFsZXJ0LXdhcm5pbmdcIiByb2xlPVwiYWxlcnRcIj5cbiAgICBTb3JyeSwgd2UgYXJlIHVuYWJsZSB0byBsb2cgeW91IGluLiBQbGVhc2UgPGEgW2hyZWZdPVwibG9naW5VcmxcIiBjbGFzcz1cImFsZXJ0LWxpbmtcIj50cnkgYWdhaW48L2E+LiBJZiB0aGUgcHJvYmxlbVxuICAgIHBlcnNpc3RzLCBwbGVhc2UgY29udGFjdCB0aGUgc3VwcG9ydCB0ZWFtLlxuICA8L2Rpdj5cbjwvZGl2PlxuIiwiPG9uZWlhbS1lcnJvcj48L29uZWlhbS1lcnJvcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBNEIsNENBQzFCO1VBQUE7VUFBQTtNQUE4QztNQUNEO1VBQUE7TUFBd0MsaURBQWE7VUFBQTtNQUU1RiwwQ0FDRjs7O1FBSDRDO1FBQUgsV0FBRyxTQUFIOzs7O29CQ0YvQztNQUFBO3FDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/errors/oneiam-error/oneiam-error.component.ngfactory.ts